/**
 * @file dispatchPrevious.ts
 * Exports a method to get the previous question id based on the current state.
 */
import { getPreviousQuestion } from '.';
import { prop } from 'ramda';
import type { AppState } from '../types';
import { actionProps } from './dispatchAnswerSingle';

/**
 * Helper method that returns the previous question id based on the state.
 *
 * @param {AppState} appState
 *   The application state before applying actions.
 *
 * @returns {string|undefined}
 *   The question id for the next question.
 */
export default (
  appState: AppState,
  action: actionProps,
): string | undefined => {
  const queId = action.queId;
  const id = prop('currentQuestion')(appState);
  return queId
    ? prop('id')(getPreviousQuestion(appState, queId))
    : prop('id')(getPreviousQuestion(appState, id));
};
